// IntelligentImportPage.jsx — Página wrapper
import React from 'react';
import IntelligentImporter from '../components/intelligentImport/IntelligentImporter';

const IntelligentImportPage = () => <IntelligentImporter />;

export default IntelligentImportPage;
